import { FC, ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from 'components/base/Button';
import FormLayout from 'components/FormLayout';
import classlist from 'utils/classlist';
import styles from './style.scss';

export interface BackNextButtonsProps {
    hidePrev?: boolean;
    sticky?: boolean;
    children?: ReactNode;
    nextBtnProps?: {
        content?: ReactNode;
    };
}

const BackNextButtons: FC<BackNextButtonsProps> = ({ hidePrev, sticky, children, nextBtnProps }) => {
    const navigate = useNavigate();
    const { content: nextBtnContent } = nextBtnProps || {};

    return (
        <div className={classlist({ [styles.sticky]: sticky })}>
            {children}
            <FormLayout className={styles.btnGroup} layout="1:2">
                {!hidePrev && (
                    <Button
                        block
                        className={classlist(styles.btnBack, styles.btnItem)}
                        type="dark"
                        size="lg"
                        ghost
                        onClick={() => navigate(-1)}>
                        {__('Go Back')}
                    </Button>
                )}
                <Button className={styles.btnItem} block type="primary" size="lg" htmlType="submit">
                    {nextBtnContent ?? __('Continue')}
                </Button>
            </FormLayout>
        </div>
    );
};

export default BackNextButtons;
